import HTTP from "../http";
import Jsona from "jsona";
import moment from "@/utils/moment";
import accountableHelper from "@/api/helpers/accountable";
import { captureException, addBreadcrumb } from "@sentry/browser";

const dataFormatter = new Jsona();

export default {
  async create(payload) {
    try {
      let data = accountableHelper.buildPhysicalRequestBody(payload);
      const user = await HTTP.normal.post(`/physicals`, data);
      return dataFormatter.deserialize(user.data);
    } catch (e) {
      addBreadcrumb({
        data: { response: JSON.stringify(e.response.data) }
      });
      captureException(e);
      throw e.response.status === 422
        ? {
            status: e.response.status,
            message: "Verifique os dados informados e tente novamente!",
            data: e.response.data
          }
        : {
            status: e.response.status,
            message: "Ocorreu um erro inesperado ao criar o seu usuário!",
            data: []
          };
    }
  },

  async createPaymentGatewayAccount(payload) {
    try {
      let address = {
        street: payload.address.street,
        street_number: payload.address.street_number,
        zip_code: payload.address.zip_code,
        complement: payload.address.complement,
        district: payload.address.district.display_name,
        city: payload.address.district.city.display_name,
        state: payload.address.district.city.state.code,
        country: payload.address.district.city.state.country.code
      };

      let phone = {
        country_code: payload.phones[0].country_code,
        area_code: payload.phones[0].area_code,
        number: payload.phones[0].number
      };

      let data = {
        data: {
          type: "payment_gateway_accounts",
          attributes: {
            name: payload.first_name,
            alt_name: payload.last_name,
            document_type: "CPF",
            document_number: payload.accountable.cpf,
            phone,
            address
          },
          relationships: {
            account: {
              data: {
                type: "accounts",
                id: payload.id
              }
            }
          }
        }
      };

      await HTTP.normal.post("/payment-gateway-accounts", data);
    } catch (e) {
      throw e;
      // throw "Ocorreu um erro ao criar a conta no meio de pagamento, contate nosso suporte!";
    }
  },

  async createPaymentGatewayCustomer(payload) {
    try {
      let address = {
        street: payload.address.street,
        street_number: payload.address.street_number,
        zip_code: payload.address.zip_code,
        complement: payload.address.complement,
        district: payload.address.district.display_name,
        city: payload.address.district.city.display_name,
        state: payload.address.district.city.state.code,
        country: payload.address.district.city.state.country.code
      };

      let phone = {
        country_code: payload.phones[0].country_code,
        area_code: payload.phones[0].area_code,
        number: payload.phones[0].number
      };

      let data = {
        data: {
          type: "payment_gateway_customers",
          attributes: {
            document_type: "CPF",
            document_number: payload.accountable.cpf,
            email: payload.email,
            fullname: payload.first_name + " " + payload.last_name,
            birthdate: moment(payload.profile.birthdate).format("Y-MM-DD"),
            phone,
            address
          },
          relationships: {
            customer: {
              data: {
                type: "physicals",
                id: payload.accountable.id
              }
            }
          }
        }
      };

      await HTTP.normal.post("/payment-gateway-customers", data);
    } catch (e) {
      throw e;
      // throw "Ocorreu um erro ao criar o cliente no meio de pagamento, contate nosso suporte!";
    }
  },

  async createOnGateway(account_id) {
    try {
      let data = {
        data: {
          attributes: {
            account_id
          }
        }
      };

      await HTTP.withAccept.post(
        "/payment-gateway-accounts/create-on-gateway",
        data
      );
    } catch (e) {
      throw "Ocorreu um erro ao criar o usuário no meio de pagamento!";
    }
  },

  async verifyEmail(account_id) {
    let data = {
      data: {
        id: account_id,
        type: "accounts"
      }
    };

    await HTTP.normal.post("/management/email-verification/send", data);
    await HTTP.normal.post("/management/email-verification/verify", data);
  },

  async getAddresses(id) {
    try {
      let results = await HTTP.normal.get(
        `/physicals/${id}?include=addresses.district.city.state.country,addresses.district.pricing`
      );
      results = dataFormatter.deserialize(results.data);
      return results.addresses;
    } catch (e) {
      throw "Ocorreu um erro ao buscar o cliente!";
    }
  },

  async update(payload) {
    try {
      let account = {
        data: {
          type: "accounts",
          id: payload.account.id,
          attributes: payload.account.attributes
        }
      };

      let profile = {
        data: {
          type: "profiles",
          id: payload.profile.id,
          attributes: payload.profile.attributes
        }
      };

      await HTTP.normal.patch(`/accounts/${payload.account.id}`, account);
      await HTTP.normal.patch(`/profiles/${payload.profile.id}`, profile);
    } catch (e) {
      throw e.response.data;
    }
  },

  async getStoreCreditCards(id) {
    try {
      const accountable = await HTTP.normal.get(
        `physicals/${id}?include=credit_cards`
      );

      return dataFormatter.deserialize(accountable.data).credit_cards;
    } catch (e) {
      throw "Não foi possível buscar os cartões salvos.";
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/physicals.js